module.exports = __webpack_public_path__ + "img/copyDisabled.82d5f7ab.svg";